import { render } from "./IntelligentLinkageMod.vue?vue&type=template&id=b9f6663c&scoped=true"
import script from "./IntelligentLinkageMod.vue?vue&type=script&lang=js"
export * from "./IntelligentLinkageMod.vue?vue&type=script&lang=js"

import "./IntelligentLinkageMod.vue?vue&type=style&index=0&id=b9f6663c&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f6663c"]])

export default __exports__